module.exports = __webpack_public_path__ + "img/9788958103448.c521b31a.jpg";